import React from 'react';
import { I18n } from 'react-redux-i18n';

import { AiCategory } from '../../models';
import { I18N_BASE } from '../../constants';
import styles from './CategoryChip.module.css';

export interface CategoryChipProps {
  category: AiCategory;
  testId?: string;
}

type Tone = 'toneCritical' | 'toneHigh' | 'toneMedium' | 'toneInfo' | 'toneGood' | 'toneNeutral';

const TONE: Record<AiCategory, Tone> = {
  pharma: 'toneCritical',
  phishing: 'toneCritical',
  hate: 'toneCritical',
  adult: 'toneCritical',
  crypto: 'toneHigh',
  counterfeit: 'toneHigh',
  romance: 'toneHigh',
  airline: 'toneHigh',
  seoFarm: 'toneMedium',
  other: 'toneNeutral',
  legitimate: 'toneGood',
  error: 'toneInfo',
};

export function CategoryChip({ category, testId }: CategoryChipProps): React.ReactElement {
  const toneClass = styles[TONE[category]];
  return (
    <span
      className={`${styles.chip} ${toneClass}`}
      data-testid={testId}
      data-category={category}
    >
      {I18n.t(`${I18N_BASE}.aiCategory.${category}`)}
    </span>
  );
}

export default CategoryChip;
